import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=f80da6f8&scoped=true"
import script from "./ProductModel.vue?vue&type=script&lang=js"
export * from "./ProductModel.vue?vue&type=script&lang=js"
import style0 from "./ProductModel.vue?vue&type=style&index=0&id=f80da6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80da6f8",
  null
  
)

export default component.exports